import customAreaDataFromJson from "../../domain/weather_routing/custom_area/mapper";
import WeatherRoutingAreaService from "../../services/area/service";
import createCustomAreaDataToJson from "../../domain/weather_routing/create_custom_area/mapper_to_json";
import HttpError from "../../services/http_error";
import { onConfig } from "@/config";

const localWeatherRoutingServerUrl = process.env.VUE_APP_LOCAL_WR_API_URL;

let config = null;
let companyId = null;
let customAreaService = null;

onConfig((c) => {
  config = c;
  companyId = c.VUE_APP_COMPANY_ID;
  customAreaService = new WeatherRoutingAreaService(
    "https://api.t-vos.com/v1.20",
    localWeatherRoutingServerUrl,
    companyId,
    customAreaDataFromJson,
    createCustomAreaDataToJson
  );
});

const getDefaultState = () => {
  return {
    allAreas: [],
    filteredAreas: [],
    fetchLoading: true,
    fetchError: null,
    deleteLoading: false,
    deleteError: null,
    selectedArea: null,
  };
};

const state = getDefaultState();

const getters = {
  fetchRequestFailed: (state) => (state.fetchError != null),
  deleteRequestFailed: (state) => (state.deleteError != null),
  noAreas: (state) => (state.filteredAreas.length === 0),
  getSelectedAreaGeoJson: (state) => {
    const areaBbox = state.selectedArea != null
      ? state.selectedArea.areaPoints.map((point) => [point.longitude, point.latitude])
      : [];

    const pointFeatures = areaBbox.map((coord, index) => {
      return {
        "id": `${index}`,
        "type": "Feature",
        "geometry": {
          "type": "Point",
          "coordinates": coord
        },
      };
    });

    return {
      type: "geojson",
      data: {
        id: "selectedArea",
        type: "FeatureCollection",
        features: [
          {
            "type": "Feature",
            "geometry": {
              "type": "Polygon",
              "coordinates": areaBbox,
              "bbox": areaBbox
            },
          },
          {
            type: "Feature",
            geometry: {
              type: "LineString",
              coordinates: areaBbox,
            },
            properties: {
              id: "selectedRoute",
            },
          },
          ...pointFeatures
        ],
      },
    };

  },
  getSelectedAreaPolygonLayer: () => {
    return {
      "id": "selectedAreaFillLayer",
      source: "selectedArea",
      "type": "fill",
      "paint": {
        "fill-color": "#64FFDA",
        "fill-opacity": 0.5
      },
    };
  },
  getSelectedAreaLineLayer: () => {
    return {
      id: "selectedAreaLine",
      type: "line",
      source: "selectedArea",
      layout: {
        "line-cap": "butt",
        "visibility": "visible"

      },
      paint: {
        "line-color": "#64FFDA",
        "line-width": 2,
      },
      filter: ["==", "$type", "LineString"],
    };
  },
  getSelectedAreaPointsLayer: () => {
    return {
      id: "selectedAreaPoints",
      type: "circle",
      source: "selectedArea",
      paint: {
        "circle-radius": 3.5,
        "circle-stroke-width": 0.8,
        "circle-stroke-color": "#64FFDA"
      },
      filter: ["==", "$type", "Point"],
    };
  },
};

const actions = {

  async fetchAllAreas({ commit, rootState }) {
    commit("SET_FETCH_LOADING_STATE");
    try {
      const accessToken = rootState.weatherRouting.weatherRoutingAccessToken;
      const response = await customAreaService.getMany(
        localStorage.getItem("quad_token"),
        accessToken
      );
      commit("SET_FETCH_SUCCESS_STATE", response);
    } catch (e) {
      if (e instanceof HttpError) {
        commit("SET_FETCH_FAILED_STATE");
        return;
      }
      commit("SET_FETCH_FAILED_STATE");
    }
  },

  async deleteArea({ dispatch, rootState, commit }, payload) {
    commit("SET_DELETE_LOADING_STATE");
    try {
      const accessToken = rootState.weatherRouting.weatherRoutingAccessToken;
      const areaId = payload.areaId;
      const theyrId = payload.theyrId;
      await customAreaService.delete(
        localStorage.getItem("quad_token"),
        accessToken,
        areaId,
        theyrId
      );
      await dispatch("fetchAllAreas");
      commit("SET_DELETE_SUCCESS_STATE");
    } catch (e) {
      if (e instanceof HttpError) {
        commit("SET_DELETE_FAILED_STATE");
        return;
      }
      commit("SET_DELETE_FAILED_STATE");
    }
  },

  filterAreasByDescription({ state, commit }, payload) {
    const description = payload.description;
    if (description != "") {
      const filteredAreas = state.allAreas.filter((area) => area.name.includes(description));
      commit("SET_FILTERED_AREAS", filteredAreas);
    }
    else {
      commit("SET_FILTERED_AREAS", state.allAreas);
    }
  }

};

const mutations = {
  SET_ALL_AREAS: (state, data) => (state.allAreas = data),
  SET_FILTERED_AREAS: (state, data) => (state.filteredAreas = data),
  SET_FETCH_LOADING_STATE(state) {
    state.fetchLoading = true;
    state.fetchError = null;
  },
  SET_FETCH_FAILED_STATE(state) {
    state.fetchLoading = false;
    state.fetchError = "Could not fetch areas";
  },
  SET_FETCH_SUCCESS_STATE(state, data) {
    state.fetchLoading = false;
    state.fetchError = null;
    state.allAreas = data;
    state.filteredAreas = data;
  },
  SET_DELETE_LOADING_STATE(state) {
    state.deleteLoading = true;
    state.deleteError = null;
  },
  SET_DELETE_FAILED_STATE(state) {
    state.deleteLoading = false;
    state.deleteError = "Deletion Failed";
  },
  SET_DELETE_SUCCESS_STATE(state) {
    state.deleteLoading = false;
    state.deleteError = null;
  },
  SET_SELECTED_AREA(state, data) {
    state.selectedArea = data;
  },
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },

};

export const weatherRoutingCustomAreasModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
